// extracted by mini-css-extract-plugin
export default {"list":"CheckedList-list_X_XsG"};